export enum ReleaseDateType {
    PREMIERE = 1,
    THEATRICAL_LIMITED = 2,
    THEATRICAL = 3,
    DIGITAL = 4,
    PHYSICAL = 5,
    TV = 6
}
